import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';

import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { TicketService } from '../../services/ticket.service';
import { DeleteTicket, DeleteTicketFailure, DeleteTicketSuccess, LoadTicket, LoadTicketFailure, LoadTickets, LoadTicketsFailure, LoadTicketsSuccess, LoadTicketSuccess, TicketActionTypes, UpdateTicket, UpdateTicketFailure, UpdateTicketSuccess } from '../actions/ticket.actions';
import { SummaryTicketListDto, SummaryTicketModel } from '../../models/summary-ticket.model';

@Injectable()
export class TicketEffects {
  constructor(
    private actions$: Actions,
    private service: TicketService
  ) { }



  
  loadTicket$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(TicketActionTypes.LoadTickets),
    switchMap((action: LoadTickets) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryTicketModel> & { summary: SummaryTicketListDto }) => {
          if (!res || !res.isSuccess) {
              return new LoadTicketsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadTicketsSuccess({
              items: res.values,
              total: res.total,
              summary: res.summary
            });
          }),
          catchError(error => of(new LoadTicketsFailure({ error })))
        )
      )
    ));



      
      loadTicketByUid$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(TicketActionTypes.LoadTicket),
        mergeMap((action: LoadTicket) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadTicketSuccess(response)),
            catchError(error => of(new LoadTicketFailure({ error })))
          )
        )
      ));


        
        updateTicket$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(TicketActionTypes.UpdateTicket),
          mergeMap((action: UpdateTicket) =>
            this.service.update(action.payload.ticket).pipe(
              switchMap(updated => [
                new UpdateTicketSuccess({ ticket: updated }),
              ]),
              catchError(error => of(new UpdateTicketFailure({ error })))
            )
          )
        ));


        
        deleteTicket$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(TicketActionTypes.DeleteTicket),
          mergeMap((action: DeleteTicket) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteTicketSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteTicketFailure({ error })))
            )
          )
        ));



}
